import {
    ROLES_REQUEST,
    ROLES_UPDATE,
    ROLES_RECEIVED,
    SET_HOME_ROUTE,
    USER_UPDATE
} from '../actions/userDetailsActions';
import { AppRoles } from '../../interfaces/authorizationInterfaces';
import { RoleTypes } from '../../helpers/enums';
import { publicRoutes } from '../../routes/appRouteList';

export interface AuthenticatedUserDetails {
    roles: AppRoles;
    hasFetchedRoles: boolean;
    homeRoute: string;
    user: any;
}

const userDetailsReducer = (userDetails: AuthenticatedUserDetails = {
    roles: {
        [RoleTypes.MarketInsights]: false,
        [RoleTypes.TruckLoadRate]: false,
        [RoleTypes.NetworkInsights]: false,
        [RoleTypes.TruckLoadRateAdmin]: false
    },
    hasFetchedRoles: false,
    homeRoute: publicRoutes.notAuthorized,
    user: null
}, action: any): AuthenticatedUserDetails => {
    switch (action.type) {
        case ROLES_REQUEST: {
            return {
                ...userDetails,
                hasFetchedRoles: false
            };
        }
        case ROLES_UPDATE: {
            return {
                ...userDetails,
                roles: { ...userDetails.roles, ...action.payload }
            };
        }
        case ROLES_RECEIVED: {
            return {
                ...userDetails,
                hasFetchedRoles: true
            };
        }
        case SET_HOME_ROUTE: {
            return {
                ...userDetails,
                ...action.payload
            };
        }
        case USER_UPDATE: {
            return {
                ...userDetails,
                user: action.payload
            };
        }
        default:
            return userDetails;
    }
};

export default userDetailsReducer;
